/* eslint-disable no-unused-vars */
import React, { memo, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Input,
  Card,
  DatePicker,
  Button,
  Col,
  Row,
  Form,
  Select,
} from "antd";
import dayjs from "dayjs";
import {
  UpdateSaveExpense,
  getEmployeeMaster,
  getOutletMaster,
} from "../../../@app/master/masterSlice";
import { useNavigate } from "react-router";

import { PlusOutlined } from "@ant-design/icons";
import apis from "../../../api/stateAPI";

const { Option } = Select;

function PcclaimreqorlForm() {
 const [emp_date, setEmpdate] = useState(
    localStorage.getItem("emp_code") || ""
  );

  const dispatch = useDispatch();

  const { getExpenseData } = useSelector((state) => {
    return state.master;
  });
  const navigate = useNavigate();

  const [form] = Form.useForm();
  const [expense, setExpense] = useState({});

  const onFinish = (values) => {
    let Data = [...getExpenseData];
    const formattedDate = values?.expense_date ? dayjs(values.expense_date).format("DD-MM-YYYY") : "";
    let newData = {
      id: Math.floor(Math.random() * 10 + 1),
      expense_date: formattedDate,     
      expense_type: values?.expense_type,
      amount: values?.amount,
      remarks: values?.remarks,
      bill_copy: values?.bill_copy,
      emp_code: emp_date,
    };

    Data = [...getExpenseData];

    Data.push(newData);

    dispatch(UpdateSaveExpense(Data));

    navigate("/pcclaimreqorl", {});

    //getExpenseData;
  };

  const handleAmount = (e) => {
    e.target.value();
  }

  useEffect(() => {
    getExpenseAPI();
  }, []);

  const getExpenseAPI = () => {
    apis.getExpenseList().then(({ data }) => {
      setExpense(data?.data);
      // dispatch(authSlice.actions.setBadgeCount(data));
      // return data;
    });
  };
  const disabledDate = (current) => {
    return current && current.format("YYYY-MM-DD") !== dayjs().format("YYYY-MM-DD");
  };

  useEffect(() => {
    dispatch(getOutletMaster());
    dispatch(getEmployeeMaster());
  }, []);

  let userLog = parseInt(localStorage.getItem("type"));

  const {
    gettingOutletMaster,
    getEmployeeMappingResponse: { data: employeeMapping = [] },
    getOutletMasterResponse: { data: dataSource },
  } = useSelector((state) => {
    return state.master;
  });

  const {
    gettingEmployeMaster,
    getEmployeeMasterResponse: { data: dataExployeeSource },
  } = useSelector((state) => {
    return state.master;
  });

  const onFinishFailed = (errorInfo) => {
   
  };

  const uploadButton = (
    <Button
      style={{ display: "flex", direction: "row" }}
      icon={<PlusOutlined style={{ marginTop: "3px", marginRight: "4px" }} />}>
      <div
        style={{
          marginLeft: "3px",
        }}>
        Update Image
      </div>
    </Button>
  );

  // const dateFormat = ['DD/MM/YYYY', 'DD/MM/YY'];

  return (
    <>
      <Card>
        <Row>
          <Col span={24}>
            <Form
              name="basic"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
              form={form}>
              <Row gutter={[15, 0]}>
                {userLog === 1 && (
                  <Col md={{ span: 6 }} xs={{ span: 24 }}>
                     <Form.Item name="outlet_Name" label="Outlet Name">
                    <Select
                      onSelect={(e) => {
                        let orl_emp_id = dataSource.find((e1) => e1?.id == e);

                        let emp_code = dataExployeeSource?.find(
                          (e) => e?.id == parseInt(orl_emp_id?.orl_id)
                        );                      
                        setEmpdate(emp_code?.employee_code);
                      }}>
                      {dataSource?.map((el) => (
                        <Option key={el?.id} value={el?.orl_emp_id}>
                          {el?.name}
                        </Option>
                      ))}
                    </Select>
                    </Form.Item>
                  </Col>
                )}
                <Col md={{ span: 3 }} xs={{ span: 24 }}>                 
                   <Form.Item name="expense_date" label="Expense Date">
                    <DatePicker 
                      width={200}
                      height={200}
                      name="ticketNo"
                      format="DD-MM-YYYY"
                      disabledDate={disabledDate}
                      defaultValue={""} 
                    />
                  </Form.Item>
                </Col>
                <Col md={{ span: 6 }} xs={{ span: 24 }}>
                  <Form.Item name="expense_type" label="Expense Type">
                    <Select>
                      {expense?.length > 0 &&
                        expense?.map((e) => {
                          return <Option key=""
                          value={e?.name}>{e?.name}</Option>;
                        })}
                    </Select>
                  </Form.Item>
                </Col>
                <Col md={{ span: 6 }} xs={{ span: 24 }}>
                <Form.Item name="amount" label="Amount">
                  <Input 
                    placeholder="Enter amount" 
                    type="number" 
                    name="amount" 
                    min="0"
                    onKeyDown={(e) => {                                                 
                      if (!(
                        (e.key >= '0' && e.key <= '9') || 
                        ['Backspace', 'Tab', 'Enter', 'ArrowLeft', 'ArrowRight', 'Delete'].includes(e.key)
                      )) {
                        e.preventDefault(); 
                      }
                    }}
                    // onChange={handleAmount}
                  />
                </Form.Item>
                </Col>
                <Col md={{ span: 6 }} xs={{ span: 24 }}>
                  <Form.Item name="remarks" label="Remarks">
                    <Input placeholder="" name="Remarks" />
                  </Form.Item>
                </Col>
               
                <Col span={24}>
                  <Row gutter={[15, 15]} style={{ justifyContent: "end" }}>
                    <Col
                      span={12}
                      style={{ textAlign: "right" }}
                      className="d-flex align-items-center justify-content-end mt-3">
                      <Form.Item className="mx-2">
                        <Button
                          className="orangeFactory"
                          type="primary"
                          htmlType="submit">
                          Submit
                        </Button>
                      </Form.Item>                  
                      <Form.Item>
                        <Button
                          onClick={() => {
                            navigate("/pcclaimreqorl", {});
                          }}>
                          Back
                        </Button>
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </Card>
      {/* {state.current_status === 'open' ? <PcadvancereqmsOpen /> : <PcadvancereqmsAssign />} */}
    </>
  );
}

export default memo(PcclaimreqorlForm);
